import { Module } from '@nestjs/common';
import { ApplicationExceptionHandler } from '@schemax-whatsapp/backend-utils';
import { SchemaxDbConnection } from '../db-connections/schemax-db-connection';
import { SchemaxInfoController } from './schemax-info.controller';
import { SchemaxInfoService } from './schemax-info.service';

@Module({
  controllers: [SchemaxInfoController],
  providers: [SchemaxInfoService, SchemaxDbConnection, ApplicationExceptionHandler]
})
export class SchemaxInfoModule {}
